import {
  IFarmInputCreditNote,
  IFarmInputInvoice,
  IFarmInputOrder,
} from 'constants/interfaces';

type CreditNoteEditTableState = {
  lineItems: LineItemState[];
};

export type LineItemState = {
  order: IFarmInputOrder;
  price?: string;
  priceError?: boolean;
  qty?: string;
  qtyError?: boolean;
  total?: number;
};

export type SetInvoice = {
  type: 'SetInvoice';
  data: {
    invoice: IFarmInputInvoice;
  };
};

export type SetCreditNote = {
  type: 'SetCreditNote';
  data: {
    creditNote: IFarmInputCreditNote;
  };
};

export type UpdatePrice = {
  type: 'UpdatePrice';
  data: {
    order: IFarmInputOrder;
    price: string;
  };
};

export type UpdateQty = {
  type: 'UpdateQty';
  data: {
    order: IFarmInputOrder;
    qty: string;
  };
};

export function creditNoteEditTableStateReducer(
  state: CreditNoteEditTableState,
  action: SetInvoice | SetCreditNote | UpdatePrice | UpdateQty,
): CreditNoteEditTableState {
  const findLineItemState = (order: IFarmInputOrder) => {
    return state.lineItems.find((item) => item.order.id === order.id);
  };

  const replaceLineItem = (newLine: LineItemState) => {
    return state.lineItems.map((item) => {
      if (item.order.id === newLine.order.id) return newLine;
      return item;
    });
  };

  switch (action.type) {
    case 'SetInvoice':
      return {
        lineItems: action.data.invoice.orders.map((order) => ({
          order: order,
          price: undefined,
          priceError: false,
          qty: undefined,
          qtyError: false,
          total: undefined,
        })),
      };

    case 'SetCreditNote':
      return {
        lineItems: state.lineItems.map((lineItem) => {
          const creditNoteLineItem = action.data.creditNote.lineItems.find(
            (creditNoteLineItem) =>
              creditNoteLineItem.orderId == (lineItem.order.id as any),
          );
          if (!creditNoteLineItem) return lineItem;
          return {
            ...lineItem,
            price: creditNoteLineItem.price.toString(),
            qty: creditNoteLineItem.quantity.toString(),
            total: creditNoteLineItem.price * creditNoteLineItem.quantity,
          };
        }),
      };

    case 'UpdatePrice': {
      const data = action.data;
      const oldLine = findLineItemState(data.order);
      const newTotal =
        parseFloat(data.price) * parseFloat(oldLine?.qty as string);
      const newLine: LineItemState = {
        ...oldLine,
        order: data.order,
        price: data.price,
        priceError:
          isNaN(data.price as any) ||
          parseFloat(data.price) <= 0 ||
          parseFloat(data.price) > data.order.price,
        total: newTotal || undefined,
      };
      return {
        ...state,
        lineItems: replaceLineItem(newLine),
      };
    }

    case 'UpdateQty': {
      const data = action.data;
      const oldLine = findLineItemState(data.order);
      const newTotal =
        parseFloat(oldLine?.price as string) * parseFloat(data.qty);
      const newLine: LineItemState = {
        ...oldLine,
        order: data.order,
        qty: data.qty,
        qtyError:
          isNaN(data.qty as any) ||
          parseFloat(data.qty) <= 0 ||
          parseFloat(data.qty) > data.order.quantity,
        total: newTotal || undefined,
      };
      return {
        ...state,
        lineItems: replaceLineItem(newLine),
      };
    }
  }
  throw new Error('Unhandled action: ' + JSON.stringify(action));
}
